import React from 'react';
import { isMonkiBrand } from "@pb/utils/brandConfig";
import IconWrapper from '../IconWrapper';
const ChevronDownIcon = (props) => {
    switch (true) {
        case isMonkiBrand:
            return (React.createElement(IconWrapper, Object.assign({}, props),
                React.createElement("path", { d: "m2.293 8.707 1.414-1.414L12 15.586l8.293-8.293 1.414 1.414L12 18.414 2.293 8.707Z" })));
        default:
            return (React.createElement(IconWrapper, Object.assign({}, props),
                React.createElement("path", { d: "M12 14.9l4.95-4.95.707.707-4.95 4.95-.707.707-5.657-5.657.707-.707L12 14.9z" })));
    }
};
export default ChevronDownIcon;
//# sourceMappingURL=ChevronDownIcon.js.map